interface UserPermissions {
  modules: string[];
  apiPermissions: string[];
  features?: string[];
  appType?: "ANALYTICS" | "CRM";
  meta?: {
    userId: string;
    organizationId: string;
    role: string;
    packageId: string;
    cacheHit: boolean;
    generatedAt: string;
  };
}

class FeatureUtils {
  static hasFeature(permissions?: UserPermissions, feature?: string): boolean {
    return (
      permissions?.features?.includes(feature?.toUpperCase() || "") ?? false
    );
  }

  static isCRMEnabled(permissions?: UserPermissions): boolean {
    return permissions?.appType === "CRM";
  }

  static isAnalyticsEnabled(permissions?: UserPermissions): boolean {
    return permissions?.appType === "ANALYTICS";
  }

  static getAppType(
    permissions?: UserPermissions
  ): "ANALYTICS" | "CRM" | undefined {
    return permissions?.appType;
  }

  static hasFullViewAccess(permissions?: UserPermissions): boolean {
    if (!permissions) return false;

    // Check if user has any FULL_VIEW features
    const fullViewFeatures =
      permissions.features?.filter((feature) =>
        // TODO: refactor this with proper package features
        feature.includes("CUSTOMER_REPORT_FULL_VIEW")
      ) || [];

    return fullViewFeatures.length > 0;
  }
}

export default FeatureUtils;
